import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50/80">
      <div className="px-6 md:px-10 py-14 md:py-16 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-background-50">
                Kakobuy<span className="text-accent-400">Finds</span>
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-xs">
              Your trusted resource for Kakobuy spreadsheet guides, product research, and smarter shopping intelligence. Updated weekly with the latest finds.
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Home</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Kakobuy Sheet</a>
              <Link to="/article/kakobuy-spreadsheet-ultimate-guide" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Ultimate Guide</Link>
              <Link to="/article/cssbuy-vs-kakobuy-comparison" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">CSSBuy vs Kakobuy</Link>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Popular Categories</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Shoes</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Hoodies &amp; Sweaters</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">T-Shirts</a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Accessories</a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Resources</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/article/kakobuy-spreadsheet-ultimate-guide" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Shopping Guide</Link>
              <Link to="/article/superbuy-spreadsheet-guide" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Superbuy Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">Full Spreadsheet</a>
              <Link to="/" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">All Categories</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {new Date().getFullYear()} Kakobuy Finds. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/40 hover:text-accent-400 transition-colors cursor-pointer">Privacy Policy</a>
            <span className="text-background-50/20">|</span>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/40 hover:text-accent-400 transition-colors cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}